import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/outfit/400.css";
import "@fontsource/outfit/500.css";
import "@fontsource/poppins/500.css";
import * as React from "react";
import { createRoot } from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import { RouterProvider } from "react-router-dom";

import "./app.css";
import MockModeToggle from "./components/mock-mode-toggle";
import { Provider } from "./components/provider";
import { router } from "./routes";
import "./sentry";
import { initStore, store } from "./store";

const wrapRoot = (el: React.ReactElement): React.ReactElement => {
  if ((window as any).ENVIRONMENT === "production") {
    return el;
  }
  return <React.StrictMode>{el}</React.StrictMode>;
};

const el = document.querySelector("#app");
const root = createRoot(el);
initStore(el as HTMLElement);
root.render(
  wrapRoot(
    <ReduxProvider store={store}>
      <Provider>
        <MockModeToggle />
        <RouterProvider router={router} />
      </Provider>
    </ReduxProvider>,
  ),
);
